<template>
    <div class="" style="padding: 0.3rem">
        <div class="item" v-for="(v,i) in list" :key="i">
            <div class="inner van-hairline--bottom">
                <img style="width: 1.8rem;height: 1.35rem" :src="v.image" alt="">
                <div style="margin-left: 0.3rem">
                    <h3 style="line-height:0.38rem;font-size: 0.28rem;padding-bottom: 0.3rem">{{v.name}}</h3>
                    <div class="desc">所属分类：视频答题</div>
                    <div class="desc">上传时间：{{new Date(v.start_time*1000).toLocaleDateString()}}</div>
                </div>
            </div>
            <div class="botm">
                <h3 v-if="v.is_study" style="color: #D7463A">未学习</h3>
                <h3 v-else style="color: #3A96D7">已学习</h3>
                <div>
                    <van-button v-if="v.is_study" round size="mini" type="danger" style="padding: 0 0.3rem" :to="'/answer/videoDati?id='+v.id">学习</van-button>
                    <van-button v-else color="#B3B3B3" round size="mini" type="danger" style="padding: 0 0.3rem" :to="'/answer/videoDati?id='+v.id">学习</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Button } from 'vant';
import {videoList} from "@/api/answer" 

Vue.use(Button);
export default {
    data(){
        return {
            modedata:{
                page: 1,
                limit: 10
            },
            list:[]
        }
    },
    mounted(){
        this.getdata();
    },
    methods:{
        getdata(){
            videoList(this.modedata).then(res=>{
                console.log(res)
                this.list = res.data
            })
        }
    }
}
</script>

<style scoped>
.item{
    box-shadow: 0px 0px 0.1rem #c5c5c5;
    border-radius: 0.1rem;
    padding: 0.3rem;
    margin-bottom: 0.3rem;
}
.inner{
    display: flex;
    padding-bottom: 0.3rem;
}
.desc{
    line-height: 0.34rem;
    font-size: 0.24rem;
    color: #999999;
}
.botm{
    padding:0.1rem 0.1rem 0 0.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>